

import React from "react";

type InputBlobProps = {
  index: number; // Input index
  value: string; // Input value
  isActive: boolean; // Whether this input should be focused
  changAction: (value: string, index: number) => void; // Change handler
  keyDownAction: (
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => void; // Keydown handler
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void; // Paste handler
  /** Element id prefix; the input's id is `${idPrefix}-${index}`. */
  idPrefix?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  autoComplete?: string;
  ariaLabel?: string;
  disabled?: boolean;
  testId?: string;
  /** Defaults to 1; a wider box 0 lets an OS one-time-code autofill land whole. */
  maxLength?: number;
};

export const InputBlob = ({
  index,
  value,
  isActive,
  changAction,
  keyDownAction,
  onPaste,
  idPrefix = "otp-input",
  inputMode,
  autoComplete = "off",
  ariaLabel,
  disabled,
  testId,
  maxLength = 1,
}: InputBlobProps) => {
  return (
    <input
      id={`${idPrefix}-${index}`}
      type="text"
      autoComplete={autoComplete}
      inputMode={inputMode}
      aria-label={ariaLabel}
      disabled={disabled}
      data-testid={testId}
      value={value}
      maxLength={maxLength}
      autoFocus={isActive}
      onChange={(e) => changAction(e.target.value, index)}
      onKeyDown={(e) => keyDownAction(e, index)}
      onPaste={onPaste} // Attach paste handler if provided
      className="w-full aspect-square flex-1 text-xl surface-primary text-center border outline-secondary rounded-xl focus:outline-hidden focus:outline-focus"
    />
  );
};
